import { z } from "zod";
export const IconTypesSchema = z.union([
    z.literal("link"),
    z.literal("media"),
    z.literal("mediaSquare"),
    z.literal("playerSquare"),
    z.literal("linkSquare"),
    z.literal("accordionPlus"),
    z.literal("accordionMinus"),
    z.literal("arrowRight"),
    z.literal("arrowLeft"),
    z.literal("dropdown"),
    z.literal("search"),
    z.literal("player"),
    z.literal("close"),
    z.literal("platformWindows"),
    z.literal("platformMac"),
    z.literal("platformIos"),
    z.literal("platformAndroid"),
    z.literal("platformPC"),
    z.literal("platformPSN"),
    z.literal("platformXbox"),
    z.literal("carouselLeft"),
    z.literal("carouselRight"),
    z.literal("discord"),
    z.literal("facebook"),
    z.literal("instagram"),
    z.literal("share"),
    z.literal("spotify"),
    z.literal("appleMusic"),
    z.literal("deezer"),
    z.literal("amazonMusic"),
    z.literal("youtubeMusic"),
    z.literal("tidal"),
    z.literal("soundCloud"),
    z.literal("twitch"),
    z.literal("vk"),
    z.literal("youtube"),
    z.literal("line"),
    z.literal("x"),
    z.literal("reddit"),
    z.literal("rhombus"),
    z.literal("volumeUp"),
    z.literal("volumeDown"),
    z.literal("pause"),
    z.literal("play"),
    z.literal("linkUrl"),
    z.literal("checkmark"),
    z.literal("chevronUp"),
    z.literal("chevronDown"),
    z.literal("playstation"),
    z.literal("xbox"),
    z.literal("roleAssassin"),
    z.literal("roleFighter"),
    z.literal("roleMage"),
    z.literal("roleMarksman"),
    z.literal("roleSupport"),
    z.literal("roleTank"),
    z.literal("roleController"),
    z.literal("roleDuelist"),
    z.literal("roleSentinel"),
    z.literal("roleInitiator"),
    z.literal("difficultyLow"),
    z.literal("difficultyMed"),
    z.literal("difficultyHigh"),
    z.literal("plus"),
    z.literal("download"),
    z.literal("downloadSquare"),
    z.literal("marqueeArrowRight"),
    z.literal("divider"),
    z.literal("square"),
    z.literal("caret"),
    z.literal("filter"),
]);
//# sourceMappingURL=icons.js.map